/**
 * Bloquea añadir al carrito vía fetch (FormData) para variantes de un producto restringido en la PDP.
 * Requiere: window.__catalogRestrictedVariantIds, window.__catalogRestrictedMessage
 */
(function catalogRestrictedCartGuard() {
  if (window.__catalogRestrictedCartGuardActive) return;
  const ids = window.__catalogRestrictedVariantIds;
  const message = window.__catalogRestrictedMessage || 'Unavailable';
  if (!ids || !ids.length || typeof fetch !== 'function') return;

  window.__catalogRestrictedCartGuardActive = true;

  const idSet = new Set(ids.map((v) => Number(v)));
  const origFetch = window.fetch;

  window.fetch = function patchedFetch(resource, config) {
    try {
      const url = typeof resource === 'string' ? resource : resource && resource.url;
      const method = config && config.method ? String(config.method).toUpperCase() : 'GET';
      if (
        method === 'POST'
        && url
        && (url.includes('/cart/add') || url.includes('/cart/add.js'))
        && config
        && config.body instanceof FormData
      ) {
        const vid = config.body.get('id');
        if (vid !== null && vid !== '' && idSet.has(Number(vid))) {
          const body = JSON.stringify({
            status: 422,
            message,
            description: message
          });
          return Promise.resolve(
            new Response(body, {
              status: 422,
              headers: { 'Content-Type': 'application/json' }
            })
          );
        }
      }
    } catch (e) {
      /* ignore */
    }
    return origFetch.apply(this, arguments);
  };
}());
